import React from 'react';
import { IconSvgProps } from '@models/common';

const UnlockOpen: React.FC<IconSvgProps> = (props) => {
  const { size = 20, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'>
      <g
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'>
        <path d='M15.8333 9.16675H4.16667C3.24619 9.16675 2.5 9.91294 2.5 10.8334V16.6667C2.5 17.5872 3.24619 18.3334 4.16667 18.3334H15.8333C16.7538 18.3334 17.5 17.5872 17.5 16.6667V10.8334C17.5 9.91294 16.7538 9.16675 15.8333 9.16675Z' />
        <path d='M5.83301 9.16655V5.83322C5.83197 4.79992 6.21491 3.80311 6.90749 3.03627C7.60006 2.26944 8.55287 1.7873 9.58093 1.68346C10.609 1.57961 11.639 1.86147 12.4709 2.47431C13.1053 2.94167 13.5901 3.57609 13.8757 4.30007' />
        <path d='M10 13V15' />
      </g>
    </svg>
  );
};

export default UnlockOpen;
